/**
 * Tells a block script whether it is running inside the block editor.
 *
 * Since WordPress moved the editor canvas into an iframe, a block script can be evaluated
 * in a document whose <body> does not exist yet. Reading `document.body.classList`
 * directly then throws "Cannot read properties of null", which is what every block script
 * in this theme used to do on every editor load.
 *
 * A missing body means the editor, not the front end: the front end always has one by the
 * time DOMContentLoaded fires. Treating it as "not the editor" would run the front-end
 * init inside the canvas, which is the opposite of what the dual-init is for.
 *
 * Lives outside src/js/ on purpose - webpack turns every file directly in src/js/ into its
 * own bundle, and this is a module, not an entry point.
 */
export const isBlockEditor = () => {
	const body = document.body;

	return (
		! body ||
		body.classList.contains( 'block-editor-page' ) ||
		body.classList.contains( 'block-editor-iframe__body' )
	);
};
